import ReactGA from 'react-ga4';
import { Autocomplete, TextField } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import OfferContext from '../../store/OfferContext'
import CurrencyContext from '../../store/CurrencyContext';
import { useTranslation } from "react-i18next";

const DurationSelector = (props) => {
    const offerCtx = useContext(OfferContext);
    const currencyCtx = useContext(CurrencyContext);
    const selectedValidity = offerCtx.selectedValidity;
    const { t } = useTranslation('common');
    const [updatedContent, setupdatedContent] = useState(false)
    const [options, setOptions] = useState([])
    const languageParentWindow = currencyCtx.languageParentWindow
    const [value, setValue] = useState(null)

    useEffect(() => {
        if (selectedValidity === null){
            setValue(null);
        }
    }, [selectedValidity])

    useEffect(() => {
        setupdatedContent(false)

        const filteredDuration = Array.from(new Set(offerCtx.data.map(offer => offer.validity)))
        filteredDuration.sort((a, b) => {
            const numA = parseInt(a)
            const numB = parseInt(b)

            return numA - numB
        })

        // if (filteredDuration.length >0) setDefaultDuration(filteredDuration[0])

        //Adding a value and option to the option to have a translated 
        const optionsWithLabel = filteredDuration.map(
            (option) => {
                if (languageParentWindow === 'eng') {
                    return {
                        label: option,
                        value: option
                    }
                } else {
                    if (option === '1 day') {
                        return {
                            label: parseInt(option) + ' ' + t('offer.day'),
                            value: option
                        }
                    } else return {
                        label: parseInt(option) + ' ' + t('offer.days'),
                        value: option
                    }
                }
            }
        )

        setOptions(optionsWithLabel)

    /* eslint-disable react-hooks/exhaustive-deps */
    }, [offerCtx.selectedValidity, offerCtx.data, updatedContent, offerCtx.selectedCountries])

    const handleChange = (_event, value) => {
        setValue(value)
        if (value) {
            offerCtx.changeValidity(value.value);
        } else {
            offerCtx.changeValidity(value)
        }
        setupdatedContent(true)

        // Track the duration selection change event
        ReactGA.event({
            category: 'duration_selection',
            action: 'change_duration',
            label: value ? value.value : 'None'
        });
    }

    if (offerCtx.error) {
        return <div>Error: {offerCtx.error}</div>
    } else if (!offerCtx.isLoaded) {
        return <div>Loading...</div>
    } else {
        return (
            <>
                {(
                    <Autocomplete
                        disablePortal
                        openText={t('label.open')}
                        closeText={t('label.close')}
                        clearText={t('label.clear')}
                        key={props.id}
                        id="combo-box-demo"
                        options={options}
                        sx={{ width: 250 }}
                        // defaultValue={defaultDuration}
                        value={value}
                        onChange={handleChange}
                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                label={t('duration.choose')}
                                style={{
                                    textAlign: "left",
                                    color: "black"
                                }}
                            />
                        }
                    />
                )}
            </>
        )
    }
}

export default DurationSelector